import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { FilterFormTypes } from "models/formTypes";
import { FilterSaveFormProps } from "models/propTypes/filterPropTypes";
//#endregion
//#region components
import GenericForm from "../../forms/genericForm";
//#endregion

const FilterSaveForm: ForwardRefRenderFunction<FormHandles, FilterSaveFormProps> = (props, ref) => {
  return (
    <GenericForm<FilterFormTypes.Save>
      formRef={ref}
      {...props}
      fields={{
        name: {
          label: TranslationKeys.Common.Name,
          type: FormEnums.FormFieldType.TEXT,
          maxLength: 200,
        },
        returnRelativeDates: {
          label: TranslationKeys.Filter.ReturnRelativeDates,
          type: FormEnums.FormFieldType.TOGGLE,
        },
      }}
    />
  );
};

export default forwardRef(FilterSaveForm);
